import { createContext } from "react";

const ProjectFormDescriptionContext = createContext();

export default ProjectFormDescriptionContext;